<div class="content">
    <div *ngIf="shown.grid" class="col-md-12 col-sm-12 col-xs-12 col-lg-12" style="padding: 10px;">
        <mat-card-header>
        <div mat-flat-button class="formclose" align="right" (click)="closeUseractivityForm()"><img src="assets/img/icons/forma-11.png"> </div>
            <mat-card-title>
                <div class="headLabel"> Activity </div>
            </mat-card-title>
        </mat-card-header>

        <table mat-table [dataSource]="dataSource" style="width: 100%;">
            <div mat-flat-button class="formclose" align="right" (click)="closeUseractivityForm()"><img src="assets/img/icons/forma-11.png"> </div>

            <ng-container matColumnDef="Sno">
                <th mat-header-cell *matHeaderCellDef>S.No</th>
                <td mat-cell *matCellDef="let element">{{dataSource.filteredData.indexOf(element)+1}}</td>
            </ng-container>

            <ng-container matColumnDef="createdOn">
                <th mat-header-cell *matHeaderCellDef>Date and Time</th>
                <td mat-cell *matCellDef="let element">{{element.createdOn}}</td>
            </ng-container>

            <ng-container matColumnDef="activityDetail">
                <th mat-header-cell *matHeaderCellDef>Search Result</th>
                <td mat-cell *matCellDef="let element">{{element.activityDetail}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
</div>